import { configureStore, PreloadedState } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import logger from 'redux-logger';
import designerSlice from '../ducks/designerDuck/designerDuck';
import ExtensionsDuck from '../ducks/extensionsDuck/extensionsDuck';
import ModulesDuck from '../ducks/modulesDuck/modulesDuck';
import ProviderDuck from '../ducks/providerDuck/providerDuck';
import SchedulesSlice from '../ducks/schedulesDuck';
import WorkflowDuck from '../ducks/workflowDuck/workflowDuck';
import workflowRunDuck from '../ducks/workflowRunDuck/workflowRunDuck';
import WorkspaceSlice from '../ducks/workspaceDuck/workspaceDuck';

export const reducer = combineReducers({
  extensions: ExtensionsDuck,
  modules: ModulesDuck,
  provider: ProviderDuck,
  workflow: WorkflowDuck,
  workspace: WorkspaceSlice,
  workflowRun: workflowRunDuck,
  designer: designerSlice,
  schedules: SchedulesSlice,
});

let middleware = (getDefaultMiddleware: () => any) => getDefaultMiddleware();

if (process.env.NODE_ENV === 'development') {
  middleware = (getDefaultMiddleware: () => any) =>
    getDefaultMiddleware().concat(logger);
}

export type StoreState = ReturnType<typeof reducer>;

const createStore = (preloadedState?: PreloadedState<StoreState>) =>
  configureStore({
    reducer,
    middleware,
    preloadedState,
  });

export const store: Store = createStore();

export type Store = ReturnType<typeof createStore>;
